export const ITEMS_PER_PAGE = 12;

export const SortByOptions = [
  { value: 'name-asc', label: 'Name (A-Z)' },
  { value: 'name-desc', label: 'Name (Z-A)' },
  { value: 'reference-asc', label: 'Reference (A-Z)' },
  { value: 'reference-desc', label: 'Reference (Z-A)' },
];
